import React, { useContext, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { Select } from "antd";
import Linechart from "../../../components/dashboard/linechart";
import TaskCard from "../../../components/cards/taskCard";
import { useTranslation } from "react-i18next";
import UploadedDocs from "../../../components/dashboard/uploadedDocs";
import { AppContext } from "../../../context/AppContext";
import { useLocation } from "react-router-dom";

const CaseDetails = () => {
  const { t } = useTranslation();

  const { selectedCase, allCases } = useContext(AppContext);
   const caseData = selectedCase || allCases?.data?.[0];

  const taskcardData = allCases?.data?.map((item, index) => ({
    id: index,
    heading: item.title || "No Title",
    date: item.deadline_date
      ? new Date(item.deadline_date).toLocaleString()
      : "No Deadline",
  }));
  const location = useLocation();
  let { caseItem } = location.state;

  console.log("caseItem: ", caseItem);
  
  if (!caseItem) {
    return <p className="text-darkGrey">No case selected</p>;
  }

  // const { Option } = Select;

  // const months = [
  //   "January",
  //   "March",
  //   "May",
  //   "July",
  //   "August",
  //   "October",
  //   "November",
  // ];
  // const taskcardData = [
  //   {
  //     heading:
  //       "Lorem ipsum dolor sit amet consectetur. Dui tellus quis morbi diam.",
  //     date: "October 5, 2024 - 2:00 PM ",
  //   },
  //   {
  //     heading:
  //       "Lorem ipsum dolor sit amet consectetur. Dui tellus quis morbi diam.",
  //     date: "October 5, 2024 - 2:00 PM ",
  //   },
  //   {
  //     heading:
  //       "Lorem ipsum dolor sit amet consectetur. Dui tellus quis morbi diam.",
  //     date: "October 5, 2024 - 2:00 PM ",
  //   },
  //   {
  //     heading:
  //       "Lorem ipsum dolor sit amet consectetur. Dui tellus quis morbi diam.",
  //     date: "October 5, 2024 - 2:00 PM ",
  //   },
  //   {
  //     heading:
  //       "Lorem ipsum dolor sit amet consectetur. Dui tellus quis morbi diam.",
  //     date: "October 5, 2024 - 2:00 PM ",
  //   },
  // ];
  return (
    <>
      <div className="dashboard-main flex flex-col gap-[31px] ">
        <div className="top flex gap-[20px] sm-s:flex-col">

          {/* Case Details Section */}
        <div className="cases-div max-w-[25%] max-sm:max-w-[100%] w-full flex flex-col pt-[18px] pb-[21px] px-[25px] gap-[24px] rounded-[20px] bg-[#F4F4F4] shadow-lg">
          <div className="flex justify-between w-100 items-center">
            <h5 className="small font-bold text-blue">
              {t("dashboard.caseManagement.details")}
            </h5>
            <p className="e-small bg-[#DFF2E3] font-medium text-[#00B521] rounded-[54px] px-4 py-[6px]">
              {t(`dashboard.caseManagement.${caseItem.status}`)}
            </p>
          </div>
          
          {/* Case Details */}
          <div className="flex flex-col gap-[15px]">
            <div className="flex items-center justify-between gap-[15px]">
              <p className="text-darkGrey font-semibold medium">
                {t("dashboard.caseManagement.caseID")}:
              </p>
              <p className="text-darkGrey font-semibold medium text-right">
                {caseItem.caseID}
              </p>
            </div>

            <div className="flex items-center justify-between gap-[15px]">
              <p className="text-darkGrey font-semibold medium">
                {t("dashboard.caseManagement.clientName")}:
              </p>
              <p className="text-darkGrey font-semibold medium text-right">
                {caseItem.clientInfo?.name || "N/A"}
              </p>
            </div>

            <div className="flex items-center justify-between gap-[15px]">
              <p className="text-darkGrey font-semibold medium">
                {t("dashboard.caseManagement.status")}:
              </p>
              <p className="text-darkGrey font-semibold medium text-right">
                {caseItem.status || "N/A"}
              </p>
            </div>

            <div className="flex items-center justify-between gap-[15px]">
              <p className="text-darkGrey font-semibold medium">
                {t("dashboard.caseManagement.deadlines")}:
              </p>
              <p className="text-darkGrey font-semibold medium text-right">
                {caseItem.deadlines
                  ? new Date(caseItem.deadlines).toLocaleDateString()
                  : "No Deadline"}
              </p>
            </div>

            <div className="flex items-center justify-between gap-[15px]">
              <p className="text-darkGrey font-semibold medium">
                {t("dashboard.caseManagement.tasks")}:
              </p>
              <p className="text-darkGrey font-semibold medium text-right">
                {caseItem.tasks || "N/A"}
              </p>
            </div>

            <div className="flex items-center justify-between gap-[15px]">
              <p className="text-darkGrey font-semibold medium">
                {t("dashboard.caseManagement.keyContacts")}:
              </p>
              <div className="text-darkGrey font-semibold medium text-right">
                {caseItem.contacts && caseItem.contacts.length > 0
                  ? caseItem.contacts.map((contact, index) => (
                      <p key={index}>{contact}</p>
                    ))
                  : "N/A"}
              </div>
            </div>
          </div>
        </div>

          {/* Upcoming Tasks Section */}
          <div class="reminder-div  flex flex-col gap-[25px] max-w-[75%] max-sm:px-[20px] w-full pt-[23px] px-[33px] sm-s:max-w-[100%] rounded-[20px] border-[1.299px] border-[rgba(255,255,255,0.28)] bg-[#F4F4F4] shadow-lg">
            <h5 className="small font-bold text-blue">
              {t("dashboard.caseManagement.upcomingTasks")}
            </h5>
            <div className="reminder-card-wrapper bg-transparent flex flex-col gap-[7px] max-sm:pr-[10px] pr-[22px] max-h-[322px] overflow-y-auto">
              {/* <TaskCard taskcardData={taskcardData} /> */}
            </div>
          </div>
        </div>
        <UploadedDocs selectedCase={caseItem} />

      </div>
    </>
  );
};

export default CaseDetails;
